import { DEFAULT_LOCALE, type Locale, getLocale, useLocale } from './locale'
import en from './messages/en'
import zh, { type Messages } from './messages/zh'

const DICTS: Record<Locale, Messages> = { zh, en }

/** 由 zh 字典结构推导出的点路径 key 联合类型,如 'inx.header.home' */
type Flatten<T, Prefix extends string = ''> = {
  [K in keyof T & string]: T[K] extends string
    ? Prefix extends ''
      ? K
      : `${Prefix}.${K}`
    : Flatten<T[K], Prefix extends '' ? K : `${Prefix}.${K}`>
}[keyof T & string]

export type MessageKey = Flatten<Messages>

function lookup(dict: Messages, key: string): string | undefined {
  let node: unknown = dict
  for (const part of key.split('.')) {
    if (typeof node !== 'object' || node === null) return undefined
    node = (node as Record<string, unknown>)[part]
  }
  return typeof node === 'string' ? node : undefined
}

/**
 * 按语言取文案;当前语言缺失时回退默认语言,再缺失回退 key 本身(便于开发期发现).
 */
export function translate(locale: Locale, key: MessageKey): string {
  return lookup(DICTS[locale], key) ?? lookup(DICTS[DEFAULT_LOCALE], key) ?? key
}

/** 非响应式取词(用当前语言);React 组件内请优先用 useT */
export function t(key: MessageKey, locale: Locale = getLocale()): string {
  return translate(locale, key)
}

/** React hook:返回绑定当前语言的取词函数,语言切换后自动重渲染 */
export function useT(): (key: MessageKey) => string {
  const locale = useLocale()
  return (key) => translate(locale, key)
}
